import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import * as mixins from '~utils/mixins';
export var editor = function editor(theme) {
  return {
    p: 2,
    background: theme.plain.backgroundColor,
    borderTop: 0,
    fontFamily: 'monospace',
    fontSize: 18,
    '* > textarea:focus': {
      outline: 'none'
    }
  };
};

if (typeof editor !== 'undefined' && editor && editor === Object(editor) && Object.isExtensible(editor) && !Object.prototype.hasOwnProperty.call(editor, '__filemeta')) {
  Object.defineProperty(editor, '__filemeta', {
    configurable: true,
    value: {
      name: "editor",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var error = {
  m: 0,
  py: 2,
  px: 3,
  bg: '#FF4757',
  fontSize: 1,
  color: 'white',
  whiteSpace: 'pre-wrap'
};

if (typeof error !== 'undefined' && error && error === Object(error) && Object.isExtensible(error) && !Object.prototype.hasOwnProperty.call(error, '__filemeta')) {
  Object.defineProperty(error, '__filemeta', {
    configurable: true,
    value: {
      name: "error",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var previewWrapper = {
  position: 'relative'
};

if (typeof previewWrapper !== 'undefined' && previewWrapper && previewWrapper === Object(previewWrapper) && Object.isExtensible(previewWrapper) && !Object.prototype.hasOwnProperty.call(previewWrapper, '__filemeta')) {
  Object.defineProperty(previewWrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "previewWrapper",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var wrapper = function wrapper() {
  return {
    height: 'auto',
    display: 'block',
    minHeight: '100%',
    width: 'calc(100% - 2px)',
    bg: 'playground.bg'
  };
};

if (typeof wrapper !== 'undefined' && wrapper && wrapper === Object(wrapper) && Object.isExtensible(wrapper) && !Object.prototype.hasOwnProperty.call(wrapper, '__filemeta')) {
  Object.defineProperty(wrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "wrapper",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var wrapperBorder = function wrapperBorder(content, showingCode) {
  var borderRadius = 4;

  if (showingCode) {
    borderRadius = content === 'preview' ? '4px 4px 0 0' : '0 0 4px 4px';
  }

  return {
    border: function border(t) {
      return "1px solid " + t.colors.playground.border;
    },
    borderTop: content === 'editor' ? 0 : undefined,
    borderRadius: borderRadius
  };
};

if (typeof wrapperBorder !== 'undefined' && wrapperBorder && wrapperBorder === Object(wrapperBorder) && Object.isExtensible(wrapperBorder) && !Object.prototype.hasOwnProperty.call(wrapperBorder, '__filemeta')) {
  Object.defineProperty(wrapperBorder, '__filemeta', {
    configurable: true,
    value: {
      name: "wrapperBorder",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var preview = {
  margin: 0,
  padding: '20px'
};

if (typeof preview !== 'undefined' && preview && preview === Object(preview) && Object.isExtensible(preview) && !Object.prototype.hasOwnProperty.call(preview, '__filemeta')) {
  Object.defineProperty(preview, '__filemeta', {
    configurable: true,
    value: {
      name: "preview",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var buttons = {
  zIndex: 9,
  display: 'flex',
  position: 'absolute',
  bottom: -20,
  right: 4
};

if (typeof buttons !== 'undefined' && buttons && buttons === Object(buttons) && Object.isExtensible(buttons) && !Object.prototype.hasOwnProperty.call(buttons, '__filemeta')) {
  Object.defineProperty(buttons, '__filemeta', {
    configurable: true,
    value: {
      name: "buttons",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var button = _objectSpread(_objectSpread({}, mixins.ghostButton), {}, {
  display: 'flex',
  alignItems: 'center',
  py: 1,
  p: 2,
  bg: 'border',
  color: 'muted',
  borderRadius: '0 0 3px 3px',
  '& ~ &': {
    ml: 1
  }
});

if (typeof button !== 'undefined' && button && button === Object(button) && Object.isExtensible(button) && !Object.prototype.hasOwnProperty.call(button, '__filemeta')) {
  Object.defineProperty(button, '__filemeta', {
    configurable: true,
    value: {
      name: "button",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var link = {
  py: 0,
  ml: 1,
  height: 22
};

if (typeof link !== 'undefined' && link && link === Object(link) && Object.isExtensible(link) && !Object.prototype.hasOwnProperty.call(link, '__filemeta')) {
  Object.defineProperty(link, '__filemeta', {
    configurable: true,
    value: {
      name: "link",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}